var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBulUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88125 15L12 10.9108L16.1187 14.9936L17 14.0955L12 9L7 14.0955L7.88125 15Z",
    fill: "#646782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBulUp);
export default __webpack_public_path__ + "static/media/ico-bul-up.a0ef51d6e544614752bf589008c06f2e.svg";
export { ForwardRef as ReactComponent };